<script>
    import { onMount, onDestroy } from 'svelte';
    import { fly, fade } from 'svelte/transition';
    import { writable } from 'svelte/store';
    import axios from 'axios';
    import { backOut } from 'svelte/easing';

    import FlashMessage from './FlashMessage.svelte';

    // API debug info
    let databaseName = writable('');
    let databaseUser = writable('');
    let databasePassword = writable('');
    let qdrantCollectionName = writable('');

    // 
    let sidebarElement;
    let categories = writable([]);
    let newCategory = '';
    let faceData = null;
    let selectedCategory = null;
    let showNewCategoryInput = false;
    let animate = false;
    let showFlashMessage = false;
    let score = 0;
    let multiplier = 1.0;
    let countdown = 20;
    let countdownInterval;
    let high_score = 0;
    let showFireAnimation = false;
    let curr_score = Math.floor(50 * multiplier);
    let showTrainButton = false;

    let api_ip = "127.0.0.1";
    let api_port = 5001;

    let is_api_connected = writable(false);
    let qdrant_connection_status = writable('');
    let pg_connection_status = writable('');
    let total_faces_labeled = writable(0);


    async function fetchApiInfo() {
        try {
            const response = await axios.get(`http://${api_ip}:${api_port}/api/info`);
            console.log("response is", response.data)
            console.log("Database name is", response.data.DATABASE_NAME)
            databaseName.set(response.data.DATABASE_NAME);
            databaseUser.set(response.data.DATABASE_USER);
            databasePassword.set(response.data.DATABASE_PASSWORD);
            qdrantCollectionName.set(response.data.qdrant_collection_name);
            qdrant_connection_status.set(response.data.qdrant_status);
            pg_connection_status.set(response.data.pg_status);
            total_faces_labeled.set(response.data.total_faces_labeled);
            is_api_connected.set(true);
        } catch (error) {
            console.error('Error fetching basic api info:', error);
            is_api_connected.set(false);
        }
    }
    async function fetchCategories() {
        try {
            const response = await axios.get(`http://${api_ip}:${api_port}/api/categories`);
            categories.set(response.data.map(category => ({ name: category, images: [] })).sort((a, b) => a.name.localeCompare(b.name)));
        } catch (error) {
            console.error('Error fetching categories:', error);
        }
    }

    async function fetchFaceData() {
        try {
            const response = await axios.get(`http://${api_ip}:${api_port}/api/face`);
            faceData = response.data;
            faceData.boundingBox = JSON.parse(faceData.boundingBox);
        } catch (error) {
            console.error('Error fetching face data:', error);
        }
    }

    async function classifyFace(category) {
        selectedCategory = category.name;
        categories.update(cats => {
            const index = cats.findIndex(cat => cat.name === category.name);
            cats[index].images.push({
                imageBase64: "data:image/jpeg;base64," + faceData.imageBase64,
                boundingBox: faceData.boundingBox
            });
            return cats;
        });
        try {
            await axios.post(`http://${api_ip}:${api_port}/api/category_selection`, {
                id: faceData.id,
                frame_id: faceData.frame_id,
                category: selectedCategory
            });
        } catch (error) {
            console.error('Error sending category selection:', error);
        }
        showFlashMessage = true;
        setTimeout(() => showFlashMessage = false, 700);
        updateScore();
        resetCountdown();
        skipFace();
    }

    function updateScore() {
        multiplier += 0.2;
        
        curr_score = Math.floor(50 * multiplier);
        calculatedMessage = `You're on a roll! ${curr_score}`;
        flashMessage = `+${curr_score}`;
        score += curr_score;
        if (score > 1000) {
            showFireAnimation = true;
            setTimeout(() => showFireAnimation = false, 3000); // Hide animation after 3 seconds
        }
    }

    function resetCountdown() {
        countdown = 20;
        clearInterval(countdownInterval);
        countdownInterval = setInterval(() => {
            countdown--;
            if (countdown <= 0) {
                multiplier = 1.0;
                if (score > high_score) {
                    high_score = score;
                }
                score = 0;
                clearInterval(countdownInterval);
            }
        }, 1000);
    }

    function getFaceStyle(imageData) {
        const { imageBase64, boundingBox } = imageData;
        const { left, top, width, height, pix_width, pix_height } = boundingBox;
        const faceWidth = width * pix_width;
        const faceHeight = height * pix_height;
        const faceLeft = left * pix_width;
        const faceTop = top * pix_height;

        return `
            background-image: url('${imageBase64}');
            background-position: -${faceLeft}px ${faceTop + faceHeight}px;
            background-size: ${pix_width}px ${pix_height}px;
            width: 200px;
            height: 200px;
        `;
    }

    function skipFace() {
        fetchFaceData();
    }

    function addCategory() {
        if (newCategory) {
            categories.update(cats => [...cats, { name: newCategory, images: [] }].sort((a, b) => a.name.localeCompare(b.name)));
            newCategory = '';
            showNewCategoryInput = false;
            setTimeout(() => {
                if (sidebarElement) {
                    sidebarElement.scrollTop = sidebarElement.scrollHeight;
                }
            }, 100);
        }
    }

    function toggleNewCategoryInput() {
        showNewCategoryInput = !showNewCategoryInput;
    }

    async function checkFaceCount() {
        let catCount = [];
        categories.subscribe(cats => {
            catCount = cats.map(cat => cat.images.length);
        });

        showTrainButton = catCount.every(count => count >= 50);
    }

    async function trainModel() {
        if (!showTrainButton) return;

        try {
            const response = await axios.get(`http://${api_ip}:${api_port}/api/train_model`);
            console.log(response.data.message);
        } catch (error) {
            console.error('Error training the model:', error);
        }
    }

    function handleKeydown(event) {
        if (event.code === 'Space') {
            skipFace();
        }
    }

    onMount(() => {
        animate = true;
        fetchFaceData();
        fetchCategories();
        resetCountdown();
        fetchApiInfo();
        const intervalId = setInterval(checkFaceCount, 60000);
        window.addEventListener('keydown', handleKeydown);

        onDestroy(() => {
            clearInterval(intervalId);
            window.removeEventListener('keydown', handleKeydown);
        });
    });

  let calculatedMessage = `You're on a roll! ${curr_score}`;
  let flashMessage = `+${curr_score}`;
</script>

<style>
    @keyframes pulsate {
        0% {
            color: rgb(73, 182, 171);
            background-color: rgb(78, 78, 78);
        }
        50% {
            color: rgb(100, 215, 200);
            background-color: rgb(97, 120, 117);
        }
        100% {
            color: rgb(73, 182, 171);
            background-color: rgb(78, 78, 78);
        }
    }

    .addButton {
        width: 200px;
        height: 80px;
        animation: pulsate 2s infinite;
    }
    .container {
        height: 100vh;
        overflow: hidden;
        display: flex;
        gap: 20px;
        padding: 20px;
        font-family: Arial, sans-serif;
    }

    .sidebar {
        flex: 0 0 200px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;
        border-radius: 8px;
        overflow-y: auto;
    }

    .categories {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 10px;
        transition: all 0.3s ease;
    }

    .categories, .actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .categories button, .actions button {
        padding: 45px;
        color: white;
        background-color: #232323;
        border: none;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        transition: background-color 0.3s;
    }

    .categories button:hover, .actions button:hover {
        background-color: #d0d0d0;
    }

    .actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .actions input {
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 5px;
    }

    .image-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1024px;
        height: 1024px;
        margin: auto;
        border-radius: 8px;
        overflow: hidden;
    }

    .image-container img {
        width: 100%;
        height: auto;
    }

    .bounding-box {
        position: absolute;
        border: 2px solid red;
    }
    .addButton {
        width: 200px;
        height: 80px;
        animation: pulsate 2s infinite;
    }
    .container {
        height: 100vh;
        overflow: hidden;
        display: flex;
        gap: 20px;
        padding: 20px;
        font-family: Arial, sans-serif;
    }

    .sidebar {
        flex: 0 0 200px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 20px;
        border-radius: 8px;
        overflow-y: auto;
    }

    .categories {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
        gap: 10px;
        transition: all 0.3s ease;
    }

    .categories, .actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .categories button, .actions button {
        padding: 45px;
        color: white;
        background: rgba(35, 35, 35, 0.6);
        border: none;
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        transition: background-color 0.3s, backdrop-filter 0.3s;
        backdrop-filter: blur(10px);
    }

    .categories button:hover, .actions button:hover {
        background: rgba(208, 208, 208, 0.8);
        backdrop-filter: blur(15px);
    }

    .categories .flash {
        background-color: green;
    }

    .actions {
        display: flex;
        flex-direction: column;
        gap: 10px;
    }

    .actions input {
        padding: 10px;
        border: 1px solid #ddd;
        border-radius: 5px;
    }

    .image-container {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 1024px;
        height: 1024px;
        margin: auto;
        border-radius: 8px;
        overflow: hidden;
    }

    .image-container img {
        max-width: 100%;
        height: auto;
    }

    .bounding-box {
        position: absolute;
        border: 2px solid red;
    }

    .score-container {
        position: fixed;
        top: 20px;
        right: 20px;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        color: white;
        font-size: 1.5rem;
    }

    .debug_info_container { 
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        position: fixed;
        bottom: 20px;
        right: 20px;
        color: white;
        font-size: 0.85rem;
    }

    .countdown {
        position: relative;
        width: 50px;
        height: 50px;
        margin-top: 10px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .fire-animation {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1000;
    }

    .fire-animation video {
        width: 80%;
        max-width: 800px;
        height: auto;
    }
    .framer-text{
        font-size:32px;
        color: white;
    }

</style>

<div class="container">
    <div class="sidebar">
        {#if showFlashMessage}
  {#if showFireAnimation}
    <FlashMessage message={calculatedMessage} />
  {:else}
    <FlashMessage message={flashMessage} />
  {/if}
{/if}

        {#if animate}
            <div transition:fade on:introstart on:outrostart on:introend on:outroend class="framer-text">
                Kyo <sub>by Kino AI</sub>
            </div>
        {/if}

        <div class="categories">
            {#each $categories as category, i (category.name)}
                <button 
                    on:click={() => classifyFace(category)} 
                    in:fly={{ x: 100, delay: 300 * i, easing: backOut }}
                    style={category.images.length ? getFaceStyle(category.images[category.images.length - 1]) : ''}>
                    <div>
                        {category.name}
                    </div>
                </button>
            {/each}
        </div>

        <div class="actions">
            {#if showNewCategoryInput}
                <div in:fly={{ y: 100, delay: 300 * categories.length, easing: backOut }} out:fade>
                    <input type="text" bind:value={newCategory} placeholder="New category" />
                    <button on:click={addCategory} class="addButton">Add</button>
                </div>
            {/if}
            <button on:click={skipFace}>Ignore</button>
            <button on:click={toggleNewCategoryInput}>+</button>
        </div>
    </div>

    <div class="image-container">
        {#if faceData}
            <img src={"data:image/jpeg;base64," + faceData.imageBase64} alt="Face to be labeled" />
            <!-- (424 - 224) / 424 * 1024 -->
            <!-- <div class="bounding-box" style="left: {faceData.boundingBox.left * 1024 }px; top: {(1 - faceData.boundingBox.top) * (224 / 424) * 1024 + 223 - faceData.boundingBox.height * (424 - 224) / 424 * 1024 }px; width: {faceData.boundingBox.width * 1024 }px; height: {faceData.boundingBox.height * (424 - 224) / 424 * 1024 }px;"></div> -->

            <div class="bounding-box" style="left: {faceData.boundingBox.left * Math.min((faceData.boundingBox.pix_width / faceData.boundingBox.pix_height), 1.0) * 1024}px; top: {(1 - faceData.boundingBox.top) * Math.min(faceData.boundingBox.pix_height / faceData.boundingBox.pix_width, 1.0) * 1024 + (Math.min(faceData.boundingBox.pix_width / faceData.boundingBox.pix_height, 1.0) * 1024 -  Math.min(faceData.boundingBox.pix_height/ faceData.boundingBox.pix_width, 1.0) * 1024) / 2 - faceData.boundingBox.height * Math.min((faceData.boundingBox.pix_height / faceData.boundingBox.pix_width), 1.0) * 1024}px; width: {faceData.boundingBox.width * Math.min((faceData.boundingBox.pix_width / faceData.boundingBox.pix_height), 1.0) * 1024 }px; height: {faceData.boundingBox.height * Math.min((faceData.boundingBox.pix_height / faceData.boundingBox.pix_width), 1.0) * 1024}px;"></div>
        {/if}
    </div>

    <div class="score-container">
        <div>High Score: {high_score.toFixed(0)}</div>
        <div>Score: {score.toFixed(0)}</div>
        <div>Multiplier: x{multiplier.toFixed(1)}</div>
        <div> total faces labeled (refresh to update): {$total_faces_labeled}</div>
        
        <div class="countdown">
            {countdown}s
        </div>
        <div class="actions">
            <button on:click={trainModel} disabled={!showTrainButton} class:disabled={!showTrainButton}>Train the Model</button>
        </div>
        
    </div>

    <div class="debug_info_container">
    {#if $is_api_connected}
            <div>API IP: {api_ip}:{api_port}</div>
            <div>database name: {$databaseName}</div>
            <div>database user: {$databaseUser}</div>
            <div>database password: {$databasePassword}</div>
            <div>qdrant collection name: {$qdrantCollectionName}</div>
            {#if $qdrant_connection_status === "connected"}
                <div style="color: green;">qdrant connected to backend api!</div>
            {:else}
                <div style="color: red;">qdrant error: {$qdrant_connection_status}</div>
            {/if}
            {#if $pg_connection_status === "connected"}
                <div style="color: green;">pg connected to backend api!</div>
            {:else}
                <div style="color: red;">pg error: {$pg_connection_status}</div>
            {/if}
    {:else}
            <div style="color: red;">COULD NOT CONNECT TO BACKEND API AT {api_ip}:{api_port}</div>
    {/if}
    </div>
</div>
